import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedProduct: "",
  selectedComponent: "",
  selectedTestSuite: "",
  selectedTestCase: null,
  selectedTestCaseName: "",
  testCaseResults: [],
  selectedTestSuiteData:[],
  debugMode: 'run',
  isDebugMode: false,
  debugStepNumber: null
};

const executionSlice = createSlice({
  name: "executionReport",
  initialState,
  reducers: {
    setSelectedProduct(state, action) {
      state.selectedProduct = action.payload;
      state.selectedComponent = initialState.selectedComponent;
    },
    setSelectedComponent(state, action) {
      state.selectedComponent = action.payload;
      state.selectedTestCase = initialState.selectedTestCase;
    },
    setSelectedTestSuite(state, action) {
      state.selectedTestSuite = action.payload;
    },
    setSelectedTestCase(state, action) {
      state.selectedTestCase = action.payload;
    },
    setSelectedTestCaseName(state, action) {
      state.selectedTestCaseName = action.payload;
    },
    setTestCaseResults(state, action) {
      state.testCaseResults = action.payload;
    },
    setSelectedTestSuiteData(state, action) {
      state.selectedTestSuiteData = action.payload;
    },
    setDebugMode(state, action) {
      state.debugMode = action.payload;
    },
    setIsDebugMode(state, action) {
      state.isDebugMode = action.payload;
    },
    setDebugStepNumber(state, action) {
      state.debugStepNumber = action.payload;
    },
    resetExecutionReport() {
      return { ...initialState }
    },
  },
});

export const {
  setTestCaseResults,
  setSelectedProduct,
  setSelectedComponent,
  setSelectedTestCase,
  setSelectedTestCaseName,
  setSelectedTestSuite,
  setSelectedTestSuiteData,
  setDebugMode,
  setIsDebugMode,
  setDebugStepNumber,
  resetExecutionReport
} = executionSlice.actions;

export default executionSlice.reducer;
